// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c2478708","66":"2164769e","77":"b55078a5","216":"6be570ad","262":"f135dd77","301":"b4afa941","328":"a940eb42","385":"a6f0db36","536":"454e370d","615":"8daa42ab","781":"6d66e561","898":"2b4328ad"}[chunkId] + ".chunk.js";
};